module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_chapel@2x-78c5242d0226814aab9ac98bd09e603d.webp";